const roles_names = {
  "kindergartenHead": "Керівник ЗДО",
  "moderator": "Модератор",
  "admin": "Адміністратор",
  "nurse": "Медична сестра",
  "kindergartenHeadPrivate": "Директор приватного садочка",
  "techassistance": "Технічна підтримка",
  "superadmin": "Адміністратор системи",
  "specialist": "Спеціаліст ДОН"
}


export {roles_names};